export default __webpack_public_path__ + "static/media/about-team-17.0efd7e7c.png";